<template>
  <span
    class="s-chip"
    :class="size ? `is_${size}` : ''"
    :style="chipStyle">
    <span 
      class="s-chip__content"
      :style="contentStyle">
      <slot>{{ text }}</slot>
    </span>
    <slot name="after"/>
  </span>
</template>
<script>
/**
 * Компонент Chip
 * @displayName Chip
 */
export default {
  name: 'sChip',
  computed: {
    contentStyle() {
      return {
        color: this.invert ? this.background : this.color,
        caretColor: this.invert ? this.background : this.color,
        filter: this.invert ? 'invert(1) hue-rotate(90deg)' : null
      }
    },
    chipStyle() {
      return {
        backgroundColor: this.background,
        borderColor: this.background
      }
    }
  },
  props: {
    /**
     * Значение для отображения
     */
    text: {
      type: [String, Number],
    },
    /**
     * Цвет текста
     */
    color: {
      type: String,
      default: 'var(--white-color)'
    },
    /**
     * Цвет фона
     */
    background: {
      type: String,
      default: 'var(--black-color)'
    },
    invert: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: ''
    }
  },
}
</script>
<style scoped lang="scss">
.s-chip {
  border-radius: 8px;
  font-size: 10px;
  min-height: 16px;
  padding: 0 8px;  
  align-items: center;
  cursor: default;
  display: inline-flex;  
  line-height: 20px;
  max-width: 100%;
  outline: none;
  overflow: hidden;
  position: relative;
  text-decoration: none;
  transition-duration: 0.28s;
  vertical-align: middle;
  white-space: nowrap;
  &.is_medium {
    min-height: 20px;
  }
  &:before {
    background-color: currentColor;
    bottom: 0;
    border-radius: inherit;
    content: "";
    left: 0;
    opacity: 0;
    position: absolute;
    pointer-events: none;
    right: 0;
    top: 0;
  }
  &__content {
    align-items: center;
    display: inline-flex;
    height: 100%;
    max-width: 100%;
    font-size: 12px;
    line-height: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
